class GatewayActions{
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.initGatewaySelectInModal('#kt-select-country', '#add_gateway_modal');
        this.createGatewayValidation();
        this.checkRedirect();
       // this.createPortForwardValidation();
        this.editGatewayEvents(this.organizationID);
        this.netteAjaxForms();

        this.membersAndGroupsDatatableInitialized = false;
    }

    netteAjaxForms(){
        $.nette.ext('editPortForwardingForm', {
            success: function (payload, status, jqXHR, settings) {
                let formID = settings.nette.form[0].attributes.id.value;
                if(formID === 'frm-generalForms-editPortForwardForm-editPortForwardForm'){
                    if(payload){
                        toastr.success('Port Forward has been successfully edited!');

                        new DismissModal('edit-port-forward-modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('edit-port-forward-modal')).hide();
                        new bootstrap.Modal(document.getElementById('gateway_port_forward_modal'), {}).show();

                        let form = $('#frm-generalForms-editPortForwardForm-editPortForwardForm');
                        form.find('input[name=ServiceName]').val('');
                        form.find('input[name=PublicPort]').val('');
                        form.find('input[name=LocalPort]').val('');
                    }

                    // Cancel loading indication
                    let submitButton = document.getElementById('edit_port_forward_form_submit');
                    submitButton.setAttribute('data-kt-indicator', 'off');
                    submitButton.disabled = false;
                    $('#port-forward-datatable').DataTable().draw();
                }
            }
        });
        $.nette.ext('portForwardingForm', {
            success: function (payload, status, jqXHR, settings) {
                let formID = settings.nette.form[0].attributes.id.value;
                if(formID === 'frm-generalForms-createPortForwardForm-createPortForwardForm'){
                    if(payload){
                        toastr.success('Port Forward has been successfully created!');

                        new DismissModal('add-port-forward-modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add-port-forward-modal')).hide();
                        new bootstrap.Modal(document.getElementById('gateway_port_forward_modal'), {}).show();
                        $('#port-forward-datatable').DataTable().columns.adjust();

                        let form = $('#frm-generalForms-createPortForwardForm-createPortForwardForm');
                        form.find('input[name=ServiceName]').val('');
                        form.find('input[name=PublicPort]').val('');
                        form.find('input[name=LocalPort]').val('');
                    }
                    // Cancel loading indication
                    let submitButton = document.getElementById('create_port_forward_form_submit');
                    submitButton.setAttribute('data-kt-indicator', 'off');
                    submitButton.disabled = false;
                    $('#port-forward-datatable').DataTable().draw();
                }
            }
        });
    }

    /** Create template and init select2 */
    initGatewaySelectInModal(selectID, dropdownParentID) {
        var optionFormat = function(item) {
            if ( !item.id ) {
                return item.text;
            }

            var span = document.createElement('span');
            var imgUrl = item.element.getAttribute('data-kt-select2-country');
            var template = '';
            template += '<img src="' + imgUrl + '" class="h-20px me-2" alt="image"/>';
            template += item.text;

            span.innerHTML = template;

            return $(span);
        };

        $(selectID).select2({
            placeholder: 'Nothing selected',
            dropdownParent: $(dropdownParentID),
            templateSelection: optionFormat,
            templateResult: optionFormat
        });
    }

    editPortForwardValidation(portForwardID) {

        let thisClass = this;

        let form = document.getElementById('frm-generalForms-editPortForwardForm-editPortForwardForm');
        if(form) {
            let submitButton = document.getElementById('edit_port_forward_form_submit');
            let validator = FormValidation.formValidation(
                form,
                {
                   fields: {
                       'VpnUser': {
                           validators: {
                               notEmpty: {
                                   message: 'This field is required'
                               }
                           }
                       },
                       'ServiceName': {
                           validators: {
                               notEmpty: {
                                   message: 'This filed is required'
                               },
                               stringLength: {
                                   min: 3,
                                   max: 45,
                                   message: 'Service name has to be 3 - 45 characters long'

                               }
                           }
                       },
                       'PublicPort': {
                           validators: {
                               notEmpty: {
                                   message: 'This field is required'
                               },
                               regexp: {
                                   regexp: /^[0-9-]+$/,
                                   message: 'You have to type in number or valid range',
                               },
                               stringLength: {
                                   max: 11,
                                   message: 'Port cannot be over 11 characters',
                               },
                               remote: {
                                   method: 'POST',
                                   url: '/gateways/?do=CheckIfRangesIsValid',
                                   data: function () {
                                       return {
                                           organizationID: thisClass.organizationID,
                                           protocol: $('select[name=Protocol]').val(),
                                           LocalPort: $('#frm-generalForms-editPortForwardForm-editPortForwardForm input[name="LocalPort"]').val(),
                                           vpnServerId: thisClass.gatewayID,
                                           portForwardID: portForwardID
                                       };
                                   },
                               },
                               callback: {
                                   message: 'You have to type in number or valid range',
                                   callback: function (input) {
                                       /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                                       if(input.value.includes('-')){
                                           const splittedArr = input.value.split('-');
                                           if(splittedArr.length <= 2){
                                               if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                                   if(+splittedArr[0] < +splittedArr[1]){
                                                       if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                           return true;
                                                       }
                                                   }
                                               }
                                           }
                                       } else {
                                           if(!isNaN(+input.value)){
                                               if(+input.value > 0 && +input.value <= 65535){
                                                   return true;
                                               }
                                           }
                                       }
                                       return false;
                                   }
                               }
                           }
                       },
                       'LocalPort': {
                           validators: {
                               notEmpty: {
                                   message: 'This field is required'
                               },
                               regexp: {
                                   regexp: /^[0-9-]+$/,
                                   message: 'You have to type in number or valid range',
                               },
                               stringLength: {
                                   max: 11,
                                   message: 'Port cannot be over 11 characters',
                               },
                               remote: {
                                   method: 'POST',
                                   url: '/gateways/?do=CheckIfRangesIsValid',
                                   data: function () {
                                       return {
                                           organizationID: thisClass.organizationID,
                                           protocol: $('select[name=Protocol]').val(),
                                           PublicPort: $('#frm-generalForms-editPortForwardForm-editPortForwardForm input[name="PublicPort"]').val(),
                                           vpnServerId: thisClass.gatewayID,
                                           portForwardID: portForwardID
                                       };
                                   },
                               },
                               callback: {
                                   message: 'You have to type in number or valid range',
                                   callback: function (input) {
                                       /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                                       if(input.value.includes('-')){
                                           const splittedArr = input.value.split('-');
                                           if(splittedArr.length <= 2){
                                               if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                                   if(+splittedArr[0] < +splittedArr[1]){
                                                       if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                           return true;
                                                       }
                                                   }
                                               }
                                           }
                                       } else {
                                           if(!isNaN(+input.value)){
                                               if(+input.value > 0 && +input.value <= 65535){
                                                   return true;
                                               }
                                           }
                                       }
                                       return false;
                                   }
                               }
                           }
                       }
                   },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                PublicPort: 0.5,
                                LocalPort: 0.5
                            }
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                            onPlaced: function (e) {
                                if (e.field === 'VpnUser') {
                                    e.iconElement.classList.add('d-none');
                                }
                            },
                        })
                    }
                }
            ).on('core.field.valid', function(field) {
                if(field == 'PublicPort' && !thisClass.checkIfFieldIsValid('frm-generalForms-editPortForwardForm-editPortForwardForm', 'LocalPort')) {
                    validator.validateField('LocalPort');
                }else if(field == 'LocalPort' && !thisClass.checkIfFieldIsValid('frm-generalForms-editPortForwardForm-editPortForwardForm', 'PublicPort')) {
                    validator.validateField('PublicPort');
                }
            });

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('edit-port-forward-modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-generalForms-editPortForwardForm-editPortForwardForm').submit();
                    }
                });
            });
        }
    }

    createPortForwardValidation() {
        let thisClass = this;

        let form = document.getElementById('frm-generalForms-createPortForwardForm-createPortForwardForm');
        if(form) {
            let submitButton = document.getElementById('create_port_forward_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'VpnUser': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                        'ServiceName': {
                            validators: {
                                notEmpty: {
                                    message: 'This filed is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 45,
                                    message: 'Service name has to be 3 - 45 characters long'
                                }
                            }
                        },
                        'PublicPort': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 11,
                                    message: 'Port cannot be over 11 characters',
                                },
                                regexp: {
                                    regexp: /^[0-9-]+$/,
                                    message: 'You have to type in number or valid range',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/gateways/?do=CheckIfRangesIsValid',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            protocol: $('select[name=Protocol]').val(),
                                            LocalPort: $('#frm-generalForms-createPortForwardForm-createPortForwardForm input[name="LocalPort"]').val(),
                                            vpnServerId: thisClass.gatewayID
                                        };
                                    },
                                },
                                callback: {
                                    message: 'You have to type in number or valid range',
                                    callback: function (input) {
                                        /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                                        if(input.value.includes('-')){
                                            const splittedArr = input.value.split('-');
                                            if(splittedArr.length <= 2){
                                                if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                                    if(+splittedArr[0] < +splittedArr[1]){
                                                        if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                            return true;
                                                        }
                                                    }
                                                }
                                            }
                                        } else {
                                            if(!isNaN(+input.value)){
                                                if(+input.value > 0 && +input.value <= 65535){
                                                    return true;
                                                }
                                            }
                                        }
                                        return false;
                                    }
                                }
                            }
                        },
                        'LocalPort': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 11,
                                    message: 'Port cannot be over 11 characters',
                                },
                                regexp: {
                                    regexp: /^[0-9-]+$/,
                                    message: 'You have to type in number or valid range',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/gateways/?do=CheckIfRangesIsValid',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            protocol: $('select[name=Protocol]').val(),
                                            PublicPort: $('#frm-generalForms-createPortForwardForm-createPortForwardForm input[name="PublicPort"]').val(),
                                            vpnServerId: thisClass.gatewayID
                                        };
                                    },
                                },
                                callback: {
                                    message: 'You have to type in number or valid range',
                                    callback: function (input) {
                                        /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                                        if(input.value.includes('-')){
                                            const splittedArr = input.value.split('-');
                                            if(splittedArr.length <= 2){
                                                if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                                    if(+splittedArr[0] < +splittedArr[1]){
                                                        if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                            return true;
                                                        }
                                                    }
                                                }
                                            }
                                        } else {
                                            if(!isNaN(+input.value)){
                                                if(+input.value > 0 && +input.value <= 65535){
                                                    return true;
                                                }
                                            }
                                        }
                                        return false;
                                    }
                                }
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                PublicPort: 0.5,
                                LocalPort: 0.5
                            }
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                            onPlaced: function (e) {
                                if (e.field === 'VpnUser') {
                                    e.iconElement.classList.add('d-none');
                                }
                            },
                        })
                    }
                }
            )
                .on('core.field.valid', function(field) {
                    if(field == 'PublicPort' && !thisClass.checkIfFieldIsValid('frm-generalForms-createPortForwardForm-createPortForwardForm', 'LocalPort')) {
                        validator.validateField('LocalPort');
                    }else if(field == 'LocalPort' && !thisClass.checkIfFieldIsValid('frm-generalForms-createPortForwardForm-createPortForwardForm', 'PublicPort')) {
                        validator.validateField('PublicPort');
                    }
                })
                .on('core.validator.validated', function (e) {
                    if (!e.result.valid) {
                        // Query all messages
                        const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                        messages.forEach((messageEle) => {
                            const validator = messageEle.getAttribute('data-validator');
                            messageEle.style.display = validator === e.validator ? 'block' : 'none';
                        });
                    }
                });

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add-port-forward-modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-generalForms-createPortForwardForm-createPortForwardForm').submit();
                    }
                });
            });
        }
    }

    changeGatewayLocationFormValidation(){
        let form = document.getElementById('frm-generalForms-changeGatewayLocationForm-changeGatewayLocationForm');
        if(form){
            let submitButton = document.getElementById('change_gateway_location_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'location': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        // Validate fields when clicking the Submit button
                        // submitButton: new FormValidation.plugins.SubmitButton(),
                        // Submit the form when all fields are valid
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            });

            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                let isInIpRestriction = $(this).attr('data-ip-restriction');
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        let gatewayName = submitButton.getAttribute('data-gateway-name');
                        let locationName = $('#change-location-select').select2('data');
                        let html = ``;
                        if(isInIpRestriction === '1'){
                            html = `
                                    <div class="text-center text-primary">Are you sure you want to change `+(gatewayName !== undefined ? `<b>`+gatewayName+`</b>` : `Gateway`)+` location to <b>`+locationName[0]['text']+`</b>?</div>
                                    <div class="text-center text-primary mt-5">The Gateway is part of the <b>IP restriction</b> for logging into the Control Panel. The new Gateway IP address will be added automatically!</div>
                                   `
                        } else {
                            html = `<span class="text-center text-primary">`+(gatewayName !== undefined ? `<b>`+gatewayName+`</b>` : `Gateway`)+` will be completely deleted and you will lose your dedicated IP address. This action cannot be undone.</span>`
                        }

                        Swal.fire({
                            html: html,
                            icon: "warning",
                            iconColor: "#FF5206",
                            buttonsStyling: false,
                            reverseButtons: true,
                            showCancelButton: true,
                            confirmButtonText: "Yes, change it!",
                            customClass: {
                                confirmButton: "btn btn-danger",
                                cancelButton: 'btn btn-light-primary'
                            },
                            showLoaderOnConfirm: true,
                            returnFocus: false,
                            allowOutsideClick: () => !Swal.isLoading(),
                            allowEscapeKey: () => !Swal.isLoading()
                        }).then((result) => {
                            if (result.isConfirmed) {
                                new DismissModal('change_gateway_location_modal').disable();
                                // Show loading indication
                                submitButton.setAttribute('data-kt-indicator', 'on');
                                // Disable button to avoid multiple click
                                submitButton.disabled = true;
                                form.submit();
                            }
                        });
                    }
                });
            });
        }
    }

    createGatewayValidation() {
        let form = document.getElementById('frm-createGatewayForm-createGatewayForm');
        if(form){
            let submitButton = document.getElementById('create_gateway_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'location': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        //defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('add_gateway_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('add_gateway_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }

    editGatewayValidation() {
        const thisClass = this;
        let form = document.getElementById('frm-generalForms-editGatewayForm-editGatewayForm');
        let setupMembersAndGroupsValidator;

        if(form) {
            let submitButton = document.getElementById('edit_gateway_submit');
            let deleteButton = document.getElementById('edit_gateway_delete');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Name cannot be over 45 characters',
                                },
                                regexp: {
                                    regexp: /^[^ ][ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zA-Z0-9#' _.-]*$/,
                                    message: 'Please use only alphanumeric and #\'_.- characters.',
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                        message: new FormValidation.plugins.Message({
                            clazz: 'fv-plugins-message-container invalid-feedback',
                            container: function (field, ele) {
                                if (field === 'members[]') {
                                    return form.querySelector('#atLeastOneMemberOrGroup');
                                }
                                return FormValidation.utils.closest(ele, '.fv-row');
                            },
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.classList.contains('d-none')){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    let alreadyShown = false;
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator && !alreadyShown ? 'block' : 'none';
                        if(validator === e.validator){
                            alreadyShown = true;
                        }
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('edit_gateway_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
            }).on('core.form.valid', function(e) {
                // Submit form
                if(thisClass.membersAndGroupsDatatableInitialized){
                    form.submit();
                } else {
                    let datatable = $('#frm-generalForms-editGatewayForm-editGatewayForm #edit-gateway-members');
                    datatable.on('init.dt', function () {
                        validator.validate().then(function(status) {
                            if (status === 'Valid') {
                                form.submit();
                            }
                        });
                    });
                }
            }).on('core.form.invalid', function(event) {
                new DismissModal('edit_gateway_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
            });

            setupMembersAndGroupsValidator = function(datatable) {
                validator.addField('members[]', {
                    validators: {
                        callback: {
                            message: 'Add at least one Member/Group or check "Add all Members"',
                            callback: function (input) {
                                let membersInGateway =  datatable.DataTable().rows(':not(.not-in-gateway.d-none).is-member').data().toArray().length;
                                let groupsInGateway = datatable.DataTable().rows(':not(.not-in-gateway.d-none).is-group').data().toArray().length;
                                let addAllMembers = form.querySelector('input[name="allMembers"]').checked;

                                let result = addAllMembers || (membersInGateway + groupsInGateway !== 0);

                                validator.validateField('name').then(function(status) {
                                    if(status === 'Valid' && !result){
                                        const postureCheckLogsTab = form.querySelector('.nav-link[href="#allowed_for_tab"]');
                                        bootstrap.Tab.getOrCreateInstance(postureCheckLogsTab).show();
                                    }
                                });

                                return result;
                            },
                        },
                    },
                });
            };

            const revalidateMembersAndGroupsValidator = function () {
                const addAllMembers = form.querySelector('input[name="allMembers"]');
                const handleInputChange = () => {
                    validator.revalidateField('members[]');
                };
                addAllMembers.addEventListener('change', handleInputChange);
            }
            revalidateMembersAndGroupsValidator();
        }

        return {
            setupMembersAndGroupsValidator: setupMembersAndGroupsValidator
        }
    }

    editGatewayEvents(){
        const thisClass = this;
        document.addEventListener('DOMContentLoaded', () => naja.initialize());

        /** When user click on edit button redraw modal form and get gateways values */
        $(document).on('click', '.edit-gateway', function(e) {
            let gatewayID = $(this).parent()[0].id;
            thisClass.showEditGatewayModal(gatewayID);
        });

        $(document).on('click', '.back-to-edit-gateway', function(e) {
            let modalID = $(this).closest('.modal.fade')[0].attributes.id.value;
            bootstrap.Modal.getInstance(document.getElementById(modalID)).hide();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('edit_gateway_modal')).show();
        });

        /** If url contains #edit-gateway - show gateway */
        if(window.location.href.includes('edit-gateway') && new URLSearchParams(window.location.search).get('gatewayID')){
            this.showEditGatewayModal(new URLSearchParams(window.location.search).get('gatewayID'));
        }
    }

    showEditGatewayModal(gatewayID){
        const thisClass = this;

        new ModalLoading();
        naja.makeRequest('GET', '/gateways/?do=getGatewayInfo', {
            'gatewayID': gatewayID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                this.membersAndGroupsDatatableInitialized = false;
                let editGatewayModal = document.getElementById('edit_gateway_modal');
                this.gatewayID = response.gatewayInfo.uuid;
                this.gatewayName = response.gatewayInfo.name;

                $('.gateway-name').text(this.gatewayName);
                this.editGatewaySideBarActions();
                this.editGatewayInput();
                let validator = this.editGatewayValidation();
                this.addPortForwardModal();
                this.initDeleteGateway(editGatewayModal, response.gatewayInfo);
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_gateway_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                new EditGatewayMembersAndGroupsDatatable(response.gatewayInfo.uuid, response.gatewayInfo.members ? response.gatewayInfo.members.length : 0, response.gatewayInfo.groups ? response.gatewayInfo.groups.length : 0);
                let datatable = $('#frm-generalForms-editGatewayForm-editGatewayForm #edit-gateway-members');
                datatable.on('init.dt', function () {
                    validator.setupMembersAndGroupsValidator($(this));
                    thisClass.membersAndGroupsDatatableInitialized = true;
                });

                this.hideGeneralModals(editGatewayModal);
                new ModalLoading(editGatewayModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteGateway(editGatewayModal, gatewayInfo){
        const thisClass = this;
        const deleteGatewayButton = editGatewayModal.querySelector('.delete-gateway');
        if(deleteGatewayButton){
            let html = ``;
            if(gatewayInfo['isInIpRestriction'] === true){
                html = `
                    <div class="text-center text-primary">`+(gatewayInfo.name !== undefined ? `<b>`+gatewayInfo.name+`</b>` : `Gateway`)+` will be completely deleted and you will lose your dedicated IP address. This action cannot be undone.</div>
                    <div class="text-center text-primary mt-5">The Gateway is part of the <b>IP restriction</b> for logging into the Control Panel. This action can cause <b>you or Admins to lose access</b>!</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="deleteGatewaySwalCheckbox" type="checkbox" value="" id="deleteGatewaySwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="deleteGatewaySwalCheckbox">
                             I agree with deleting this Gateway
                        </label>
                    </div>
                   `
            } else {
                html = `<span class="text-center text-primary">`+(gatewayInfo.name !== undefined ? `<b>`+gatewayInfo.name+`</b>` : `Gateway`)+` will be completely deleted and you will lose your dedicated IP address. This action cannot be undone.</span>`
            }
            deleteGatewayButton.addEventListener('click', function () {
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    customClass: {
                        confirmButton: "btn btn-danger",
                        cancelButton: 'btn btn-light-primary',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        let deleteGatewaySwalCheckbox = document.querySelector('input[name="deleteGatewaySwalCheckbox"]');
                        if(deleteGatewaySwalCheckbox && !deleteGatewaySwalCheckbox.checked){
                            Swal.showValidationMessage(`You need to agree with deletion`);
                            return;
                        }

                        return fetch('/gateways/?do=removeGateway&organizationID='+thisClass.organizationID+'&gatewayID='+gatewayInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value === 'deleted') {
                            toastr.success('Gateway has been deleted.');
                            bootstrap.Modal.getOrCreateInstance(editGatewayModal).hide();
                            new PageDatatableReload();
                        } else {
                            Swal.fire({
                                title: 'Error',
                                icon: 'error',
                                text: 'Gateway deletion limit exceeded!',
                                customClass: {
                                    confirmButton: 'btn btn-light-primary'
                                }
                            });
                        }
                    }
                });
            });
        }
    }
    hideGeneralModals(editGatewayModal){
        let memberPrivateIPsModal = document.getElementById('team_member_private_ips_modal');
        if(memberPrivateIPsModal && memberPrivateIPsModal.classList.contains('show')){
            bootstrap.Modal.getInstance(memberPrivateIPsModal).hide();
            new AddBackLinkToModal(memberPrivateIPsModal, editGatewayModal);
        }
        let editMemberModal = document.getElementById('edit_team_member_modal');
        if(editMemberModal && editMemberModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editMemberModal).hide();
            new AddBackLinkToModal(editMemberModal, editGatewayModal);
        }
    }
    editGatewayInput(){
        const thisClass = this;
        $('#frm-generalForms-editGatewayForm-editGatewayForm .editable-text .edit-section').on('click', function(e) {
            let mainDiv = $(this).parent().parent();
            let input = mainDiv.find('.not-edit');
            input.removeClass('not-edit d-none');
            mainDiv.find('.editable-text').remove();
            //thisClass.validateEditForm();
        });
    }

    editGatewaySideBarActions(){
        const thisClass = this;
        $('.open-port-forwarding').on('click', function() {
            thisClass.openGatewayPortForwarding();
            thisClass.returnToEdit();
        });

        /** When user click on change gateway location */
        $('.change-gateway-location').on('click', function(e) {
            $(this).find('.menu-title').after('<span class="menu-spinner spinner-border spinner-border-sm align-middle ms-2"></span>');
            naja.makeRequest('GET', '/gateways/?do=getChangeGatewayLocationInfo', {
                'gatewayID': thisClass.gatewayID,
                'organizationID': thisClass.organizationID
            }, {
                history: false // Prevent URL changes in browser history
            }).then((response) => {
                if(response){
                    let editGatewayModal = document.getElementById('edit_gateway_modal');

                    thisClass.changeGatewayLocationFormValidation();
                    thisClass.initGatewaySelectInModal('#change-location-select', '#change_gateway_location_modal');

                    editGatewayModal.querySelector('.menu-spinner').remove();

                    bootstrap.Modal.getOrCreateInstance(editGatewayModal).hide();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('change_gateway_location_modal')).show();
                }
            }).catch(error => {
                let editGatewayModal = document.getElementById('edit_gateway_modal');
                editGatewayModal.querySelector('.menu-spinner').remove();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
            });
        });
    }

    openGatewayPortForwarding() {
        portForwardDatatable.init(this.gatewayID);
        $('.pf-gateway-name').text(this.gatewayName);
        bootstrap.Modal.getInstance(document.getElementById('edit_gateway_modal')).toggle();
        new bootstrap.Modal(document.getElementById('gateway_port_forward_modal'), {}).show();
        $('#port-forward-datatable').DataTable().columns.adjust();
    }

    returnToEdit() {
        $('.back-to-edit-gateway').on('click', () => {
            bootstrap.Modal.getInstance(document.getElementById('gateway_port_forward_modal')).toggle();
            bootstrap.Modal.getInstance(document.getElementById('edit_gateway_modal')).toggle();
        });
    }

    returnToPortForwardModal(type, activeModal) {
        $('.back-to-port-forwarding#'+type).on('click', () => {
            bootstrap.Modal.getInstance(document.getElementById(activeModal)).toggle();
            bootstrap.Modal.getInstance(document.getElementById('gateway_port_forward_modal')).toggle();
        });
    }

    addPortForwardModal(){
        const thisClass = this;
        $('.add-port-forward').on('click', function () {
            thisClass.addPortForwardActions();
        });
    }

    addPortForwardActions(){
        const thisClass = this;

        let gatewayPortForwardModal = document.getElementById('gateway_port_forward_modal');
        new ModalLoading();
        bootstrap.Modal.getInstance(gatewayPortForwardModal).hide();
        naja.makeRequest('GET', '/gateways/?do=getAllIpsForTMs', {
            'gatewayID': thisClass.gatewayID,
            'organizationID': thisClass.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                if(response['vpnUserIps'].length === 0) {
                    Swal.fire({
                        html: `<span class="text-center text-primary">You don't have any members to set port forwarding on!.</span>`,
                        icon: "error",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        showCancelButton: false,
                        confirmButtonText: "Cancel",
                        customClass: {
                            confirmButton: "btn btn-light-primary mt-0"
                        },
                    }).then(() => {
                        new ModalLoading(gatewayPortForwardModal);
                    });
                } else {
                    thisClass.createPortForwardValidation();
                    thisClass.initCreatePortForwardSelect2('#frm-generalForms-createPortForwardForm-createPortForwardForm', '#add-port-forward-modal');
                    KTScroll.createInstances();
                    $.nette.load();
                    new ModalLoading(document.getElementById('add-port-forward-modal'));
                    thisClass.returnToPortForwardModal('add-port', 'add-port-forward-modal');
                }
            }
        }).catch(error => {
            new ModalLoading(gatewayPortForwardModal);
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }

    initCreatePortForwardSelect2(form, parent){
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') +'</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        let dropdownParent =  $(parent);
        let vpnUser = $(form+' select[name=VpnUser]');
        let protocol = $(form+' select[name=Protocol]');
        vpnUser.select2({
            placeholder: "Select an option",
            templateSelection: optionFormat,
            templateResult: optionFormat,
            dropdownParent: dropdownParent
        });
        protocol.select2({
            minimumResultsForSearch: -1,
            dropdownParent: dropdownParent
        });
    }

    editPortForwardModal() {
        let thisClass = this;
        $('.edit-port-forward').on('click', function() {
            thisClass.editPortForwardActions(this);
            thisClass.returnToPortForwardModal('edit-port','edit_port_forward');
        })
    }

    editPortForwardActions(e) {
        let thisClass = this;
        let portForwardID = $(e).parent()[0].id;

        let gatewayPortForwardModal = document.getElementById('gateway_port_forward_modal');
        new ModalLoading();
        bootstrap.Modal.getInstance(gatewayPortForwardModal).hide();
        naja.makeRequest('GET', '/gateways/?do=GetPortForwardInfo', {
            'gatewayID': thisClass.gatewayID,
            'organizationID': thisClass.organizationID,
            'portForwardID': portForwardID
        }, {
            history: false // Prevent URL changes in browser history
        }).then(() => {
            $('#frm-generalForms-editPortForwardForm-editPortForwardForm input[name=PortForwardID]').val(portForwardID);
            $.nette.load();
            thisClass.initCreatePortForwardSelect2('#frm-generalForms-editPortForwardForm-editPortForwardForm', '#edit-port-forward-modal');
            KTScroll.createInstances();
            new ModalLoading(document.getElementById('edit-port-forward-modal'));
        }).catch(error => {
            new ModalLoading(gatewayPortForwardModal);
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }

    checkIfFieldIsValid(form, field) {
        let element =  $('#'+form+' input[name="'+field+'"]')
        if( element.val() === '')
            return true
        return element.parent().hasClass('fv-plugins-bootstrap5-row-valid');
    }

    checkRedirect() {
        if(window.location.href.indexOf('add_gateway=') !== -1) {
            new bootstrap.Modal(document.getElementById('add_gateway_modal'), {}).show();
        }
    }
}

window.GatewayActions = GatewayActions;